import React from 'react';

import { Box, BoxProps, FlexBox } from '@kis-technologies/kis-ui';

const PlaceholderBox = (boxProps: BoxProps) => (
  <Box width={80} height={5} sx={{ backgroundColor: '#EFEFEF' }} {...boxProps} />
);

interface ImageUploadPreviewProps {
  fileUrl: string;
  width: number;
  halfPreview?: boolean;
  imageType?: string;
}
export const ImageUploadPreview: React.FC<ImageUploadPreviewProps> = (props: ImageUploadPreviewProps) => {
  const { fileUrl, width, imageType, halfPreview = false } = props;
  const height = Math.floor(width * 1080) / 1920;

  if (imageType === 'genre' || imageType === 'event' || imageType === 'venue') {
    return <img alt="preview" width={200} height={150} src={fileUrl} style={{ objectFit: 'cover' }} />;
  }

  if (imageType === 'logo-image' || imageType === 'logo-image-large') {
    return <img alt="preview" width={width} height={height} src={fileUrl} style={{ objectFit: 'scale-down' }} />;
  }

  if (halfPreview) {
    return (
      <FlexBox direction="row" margin="3 0" width={width} height={height} sx={{ border: `1px solid ${'#D8D8D8'}` }}>
        <img alt="preview" width={width / 2} height={height} src={fileUrl} style={{ backgroundSize: 'cover' }} />
        <FlexBox direction="column" align="center" justify="center" fullHeight flexOverride="1" sx={{ flex: '1 1 0%' }}>
          <PlaceholderBox />
          <PlaceholderBox margin="2 0 4" />
          <PlaceholderBox width={40} />
        </FlexBox>
      </FlexBox>
    );
  }

  return <img alt="preview" width={width} height={height} src={fileUrl} style={{ objectFit: 'cover' }} />;
};
